import { render, staticRenderFns } from "./transcription-min-checks.vue?vue&type=template&id=841bacf6&scoped=true&lang=pug&"
import script from "./transcription-min-checks.vue?vue&type=script&lang=ts&"
export * from "./transcription-min-checks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841bacf6",
  null
  
)

export default component.exports